export const getClassNameByStatus = (status: boolean | null) => {
  if (status === null) {
    return 'warning';
  } else if (status === true) {
    return 'success';
  } else {
    return 'danger';
  }
}

export const categorizeItemsByStatus = (status: boolean | null) => {
  if (status === null) {
    return 'Pending';
  } else if (status === true) {
    return 'Whitelisted';
  } else {
    return 'Blacklisted';
  }
}

export const displayOrNA = (value: unknown, fallback: string = '--') => {
  if (value === null || value === undefined) return fallback
  if (typeof value === 'string' && value.trim() === '') return fallback
  return String(value)
}

/** Lowercase trim for role comparisons (API may send Manager / manager / MANAGER) */
export const normalizeRoleKey = (r?: string) => String(r || '').trim().toLowerCase()

/** Customer Support agent (not end-customer app user) */
export const isCustomerSupportRole = (role?: string, userType?: string): boolean => {
  const r = normalizeRoleKey(role || userType || '')
  return r === 'customersupport' || r === 'customer_support'
}

/** Manager → `/manager/dashboard` */
export const isManagerRole = (role?: string, userType?: string): boolean => {
  return normalizeRoleKey(role || userType) === 'manager' || normalizeRoleKey(userType) === 'manager'
}

/** Spectator or Developer → `/spectator/dashboard` */
export const isSpectatorOrDeveloperRole = (role?: string, userType?: string): boolean => {
  const r = normalizeRoleKey(role || userType)
  return r === 'spectator' || r === 'developer'
}

/**
 * Any role that uses the shared analytics dashboard UI (Manager has its own URL).
 */
export const isSpectatorDashboardRole = (role?: string, userType?: string): boolean => {
  return isManagerRole(role, userType) || isSpectatorOrDeveloperRole(role, userType)
}

/**
 * Get dashboard path based on user role
 * Manager → /manager/dashboard | Spectator/Developer → /spectator/dashboard
 */
export const getDashboardPath = (role?: string, userType?: string): string => {
  const userRole = role || userType

  if (userRole === 'CUSTOMER_SUPPORT' || userRole === 'CustomerSupport') {
    return '/customer-support/dashboard'
  }
  if (isManagerRole(role, userType)) {
    return '/manager/dashboard'
  }
  if (isSpectatorOrDeveloperRole(role, userType)) {
    return '/spectator/dashboard'
  }
  if (userRole === 'SUPER_ADMIN' || userRole === 'SuperAdmin' || userRole === 'Admin') {
    return '/dashboard'
  }
  return '/dashboard'
}

/**
 * Get API endpoint based on user role
 * @param role - The role from auth state
 * @param baseEndpoint - Base endpoint (e.g., 'dashboard', 'profile')
 * @returns Role-based API endpoint
 */
export const getRoleBasedApiEndpoint = (role?: string, baseEndpoint: string = 'dashboard'): string => {
  if (role === 'CUSTOMER_SUPPORT' || role === 'CustomerSupport') {
    return `auth/customer-support/${baseEndpoint}/`
  }
  if (role === 'Spectator' || role === 'Developer' || role === 'Manager') {
    return `auth/useradmin/Spectator/${baseEndpoint}/`
  }
  return `auth/useradmin/${baseEndpoint}/`
}
